import { CheckCircleIcon } from "@heroicons/react/solid";
import React from "react";
import { Link } from "react-router-dom";
import { Signin } from "../components";
import { useAuth } from "../contexts/AuthContext";

function Success() {
  const { currentUser, signout } = useAuth();
  if (!currentUser) {
    return <Signin />;
  } else {
    return (
      <>
        <div className="flex justify-center px-4 py-16 lg:py-60">
          <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                  <CheckCircleIcon
                    className="h-6 w-6 text-primary"
                    aria-hidden="true"
                  />
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Payment Received.
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Thank you for your purchase, your credit balance should
                      reflect the new balance soon. It may take a few seconds to
                      update.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <Link to="/dashboard">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Go to Dashboard
                </button>
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Success;
